/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AgentVersion } from "./AgentVersion";
export const ListAgentVersionsResponse = core.serialization.object({
    data: core.serialization.list(AgentVersion).optional(),
});
